<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="epi"> </p>
<p class="ep-bot">“All happy families resemble each other, but each unhappy family is unhappy in its own way.”</p>
<p class="epc">L<span class="epub-sc">EO</span> T<span class="epub-sc">OLSTOY</span>, <span class="epub-i">Anna Karenina</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?6f7f42be